import { Controller } from "@hotwired/stimulus"
import { track } from "../lib/mixpanel"

// Timesheets → Export → Certified payroll (WH-347) (Kloepfer K9-21): pick the
// Davis-Bacon job, see its payroll number, then Make WH-347. The link's
// pending-time check (time-export-check, K13-18) runs next and downloads it.
export default class extends Controller {
  static targets = ["modal", "job", "number", "link", "noWd"]

  open() {
    // The Export menu closes on this, like for any pop-up.
    document.dispatchEvent(new CustomEvent("modal:open"))
    this.pick()
    this.modalTarget.classList.remove("hidden")
    track("Certified Payroll Opened", { jobs: this.jobTarget.options.length })
  }

  pick() {
    const option = this.jobTarget.selectedOptions[0]
    if (!option) return
    this.linkTarget.href = option.dataset.url
    this.numberTarget.textContent = option.dataset.number
    this.noWdTarget.classList.toggle("hidden", option.dataset.wd !== "")
  }

  make() {
    track("Certified Payroll Requested", { project_id: Number(this.jobTarget.value), payroll_number: Number(this.numberTarget.textContent) })
    this.close()
  }

  close() {
    this.modalTarget.classList.add("hidden")
  }

  stopPropagation(event) {
    event.stopPropagation()
  }
}
